import React from 'react';
import type { Extraction } from '../../types/extraction';

interface Props {
  extractions: Extraction[];
  selectedId?: string;
  onVersionChange: (extractionId: string) => void;
}

function formatLabel(e: Extraction): string {
  const v = `v${e.version ?? '?'}`;
  if (e.validated_at) {
    const d = new Date(e.validated_at).toLocaleDateString('fr-CA');
    return `${v} (validée ${d})`;
  }
  if (e.is_current) return `${v} (en attente)`;
  return v;
}

const VersionSelector: React.FC<Props> = ({
  extractions,
  selectedId,
  onVersionChange,
}) => {
  if (!extractions.length) return null;

  // Default to current if no explicit selection
  const current = extractions.find((e) => e.is_current);
  const value = selectedId ?? current?.id ?? extractions[0].id;

  return (
    <select
      aria-label="Version de l'extraction"
      value={value}
      onChange={(e) => onVersionChange(e.target.value)}
      className="px-3 py-1.5 border border-gray-300 rounded-md text-sm bg-white"
    >
      {extractions.map((e) => (
        <option key={e.id} value={e.id}>
          {formatLabel(e)}
        </option>
      ))}
    </select>
  );
};

export default VersionSelector;
